
import React from 'react';
import LoyaltyOutlinedIcon from '@material-ui/icons/LoyaltyOutlined';
import StoreOutlinedIcon from '@material-ui/icons/StoreOutlined';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import CreditCard from '@material-ui/icons/CreditCard';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import RestaurantOutlinedIcon from '@material-ui/icons/RestaurantOutlined';
import EuroSymbolIcon from '@material-ui/icons/EuroSymbol';
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';
import TextFieldsOutlinedIcon from '@material-ui/icons/TextFieldsOutlined';
import InsertPhotoOutlinedIcon from '@material-ui/icons/InsertPhotoOutlined';
import product from '../assets/pictures/product.png';
import links from '../assets/pictures/links.png';
import { UNIT } from './theme';
import SettingsIcon from '@material-ui/icons/Settings';
import StarBorderOutlinedIcon from '@material-ui/icons/StarBorderOutlined';
import ListOutlinedIcon from '@material-ui/icons/ListOutlined';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';

const webIcon = {
  width: UNIT * 1.4375,
  opacity: 0.7
};
export const ALL_ORDER_TYPES = ['delivery', 'click_and_collect', 'click_and_seat'];

export const ORDER_TYPES = {
  'Commande à distance': ['delivery', 'click_and_collect', 'click_and_seat'],
  'Borne': ['click_and_seat', 'click_and_collect'],
  'QR Code': ['click_and_seat']
};

export const SUITABLE_TECHS = {
  terminal: 'Borne',
  qrcode: 'QR Code',
  webapp: 'Commande à distance'
};

export const ICON_ORDER_TYPES = {
  delivery: <DirectionsBikeIcon />,
  click_and_collect: <LocalMallOutlinedIcon />,
  click_and_seat: <RestaurantOutlinedIcon />
};

export const SUITABLE_ORDER_TYPES = {
  delivery: 'Livraison',
  click_and_collect: 'Emporter',
  click_and_seat: 'Sur place'
};
export const CANALS = {
  WEBAPP: 'Application web',
  MOBILEAPP: 'Application mobile'
};
export const ALL_PAYMENT_TYPES = {
  'Commande à distance': ['stripe', 'cash', 'ticket_resto', 'cb', 'counter', 'to_driver'],
  'Borne': ['cash', 'ticket_resto', 'cb', 'counter'],
  'QR Code': ['stripe', 'cash', 'ticket_resto', 'cb', 'counter']
};

export const SUITABLE_PAYMENT_TYPES = {
  stripe: 'Paiement en ligne',
  cb: 'En carte bancaire à réception',
  cash: 'En espèces à réception',
  ticket_resto: 'En ticket restaurant',
  counter: 'Paiement au comptoir',
  to_driver: 'Paiement au livreur'
};
export const PAYMENT_TYPE_TO_DRIVER = 'to_driver'
export const ICON_PAYMENT = {
  stripe: <ShoppingCart />,
  cb: <CreditCard />,
  cash: <EuroSymbolIcon />,
  ticket_resto: <LoyaltyOutlinedIcon />,
  counter: <StoreOutlinedIcon />,
  to_driver: <LocalShippingOutlinedIcon />
};

// CONSTANTE FOR TEXT FIELD INPUT FOR THE LAUNCHING PAGE COMPONENT:
export const PAYMENT_TYPE_CB = 'cb';
export const PAYMENT_TYPE_STRIPE = 'stripe';
export const PAYMENT_TYPE_CONTRACT = 'contract';
export const PAYMENT_TYPE_COUNTER = 'counter';
export const PAYMENT_TYPE = 'payment';
export const ORDER_TYPE = 'vente';
export const INPUT_SIREN_MAX_LENGTH = 9;
export const PAYMENT = 'payment';
export const INPUT_PHONE_MAX_LENGTH = 10;
export const DISHOP = 'dishop';
export const NETWORK = 'network';
export const DRIVER = 'driver';
export const SHOP = 'shop';
export const USER = 'user';
export const TYPES = ['SA', 'SAS', 'SASU', 'SARL', 'SNC', 'EURL', 'EIRL'];
export const USERS = ['client', 'shop', 'driver'];
export const ALLSHOP = 'Tous les magasins';
export const FREEDELIVERY = 'delivery_free';
export const TITLE_DESCRIPTION = 'Bienvenue chez';
export const CLIENT_SPACE = 'Mon espace client';
export const NEW_PRODUCTS_DESCRIPTION = 'En ce moment ⭐ !';
export const LOYALTY_NAME = 'Ma fidélité';
export const PROMOTYPES = {
  freeDelivery: 'Livraison gratuite',
  percentage: 'Pourcentage',
  euro: 'Euro'
};
export const MANAGEMENT_FEE = 'managementFee';
export const DELIVERY_FEE = 'deliveryFee';
export const SYNC_SHOPS = 'Synchroniser les magasins';
export const SYNC_HUBRISE = 'Synchroniser avec HubRise';
export const SYNC_POS = 'Synchroniser avec la caisse';
export const ALL_ORDERS = 'allOrders';
export const DEFAULT_SLOT_INTERVAL = 30;
export const SAVE_BUTTON_TEXT = 'ENREGISTRER';
export const SALES_TYPES = 'sales-type';
export const PAYMENTS_TYPES = 'payments';
export const INITIAL_HOUR_VALUE = '00:00-00:00';
export const SUCCESS_UPDATE_TEXT = 'Modification réussie';
export const SUCCESS_DELETE_TEXT = 'Suppression réussie';
export const DEFAULT_RADIUS = 1000;
export const DRIVERS_PULL_INTERVAL = 30 * 60 * 1000; //toutes les 30 min
export const PULL_INDEPENDENT_DRIVERS_INTERVALL_ORDERS = 3 * 60 * 1000; //toutes les 5min
export const DISPLAY_REOPEN_SHOP_MODAL_INTERVAL = 5 * 60 * 1000;
export const MAX_SLOT_INTERVAL = 60;
export const MIN_SLOT_INTERVAL = 10;
export const LIST_DESIGN_TYPE = ['Web', 'Mobile'];
export const SYNC_POS_TEXT = 'Synchronisation avec la caisse';

export const mobileConfig = {
  media: {
    text: 'Médias',
    icon: <InsertPhotoOutlinedIcon />,
    description: 'Ajouter ou modifier les photos'
  },
  text: {
    text: 'Texte',
    icon: <TextFieldsOutlinedIcon />,
    description: 'Ajouter ou modifier un texte'
  },
  product: {
    text: 'Produits',
    icon: <img src={product} alt='displayImage' style={webIcon} />,
    description: 'Choix et ajout des produits'
  },
  link: {
    text: 'Liens',
    icon: <img src={links} alt='displayImage' style={webIcon} />,
    description: 'Ajouter ou modifier les liens externes'
  }
};

export const BUSINESS_TYPE_CODE = {
  'Restaurant fast food': '5814',
  'Restaurant traditionnel': '5812',
  'Primeur': '5431',
  'Boulangerie': '5462',
  'Chocolaterie': '5441',
  'Pâtisserie': '5462',
  'Boucherie': '5421',
  'Glacier': '5812',
  'Poissonier': '5422'


};
export const ZELTY = 'zelty';
export const HUBRISE = 'hubrise';
export const BIBORNE = 'biborne';
export const SPLASH = 'splash';
export const ONETOUCH = 'oneTouch';
export const ADDITION = 'addition';
export const INGREDIENT = 'ingredient';
export const PRODUCT = 'product';
export const EXTRA = 'extra';
export const MENU = 'menu';
export const ADDITIONAL = 'additional';
export const POS_TYPES = {
  addition: 'menu,product,extra',
  biborne: 'menu,product,additional,extra',
  splash: 'product,ingredient'
}
export const ALL_POS_TYPES = {
  product: 'Produit',
  extra: 'Option',
  menu: 'Menu',
  ingredient: 'Option'
}
export const BIBORNE_POS_TYPES = {
  menu: 'Menu',
  product: 'Sous produit',
  additional: 'Produit additionnel',
  extra: 'Option'
}
export const PRODUCT_WITHOUT_REF = {
  name: 'Produit sans réference',
  ref: '$',
  type: 'product',
  price: 0
}
export const SUFFIX = 'TAILLE,SUB_,_ADD,PRODUCT_,OPTION_,_FOR_MENU,SECTION_,ITEM_';
export const CUSTOM_INTEGREDIENT = ['customSplashIngredients', 'customAdditionIngredients', 'customBiborneIngredients']
export const LOYALTY_CONFIG = {
  config: {
    text: 'Configuration',
    icon: <SettingsIcon />,
    description: 'Définissez quelques paramètres de base'
  },
  version: {
    text: 'Versions',
    icon: <DynamicFeedIcon />,
    description: 'Définissez les différentes versions de votre fidélité'
  }
};
export const VERSION_MENU = {
  config: {
    text: 'Configuration',
    icon: <SettingsIcon />,
    description: 'Réglages de la version'
  },
  resto: {
    text: 'Restaurants participants',
    icon: <ListOutlinedIcon />,
    description: 'Définissez les restaurants participants au programme'
  },
  product: {
    text: 'Produits offerts',
    icon: <StarBorderOutlinedIcon />,
    description: 'Définissez la liste des produits offerts'
  }
};
export const CASHBACK_TYPE = 'cashback'
export const PRODUCT_TYPE = 'product'
export const CHART_COLORS = ['rgb(60, 141, 47)', 'rgb(123, 180, 122)', 'rgb(165, 208, 169)'];
export const CAMPAIGN_TYPE = {
  socialNetworks: 'Réseaux sociaux (communication gratuite)',
  ads: 'Réseaux sociaux (publicité payante)',
  packaging: 'Emballage',
  poster: 'Affichage en point de vente',
  outdoorDisplay: 'Affichage extérieur',
  flyer: 'Flyer',
  email: 'Email',
  sms: 'SMS',
  phone: 'Téléphone',
  contest: 'Concours',

};
export const ANALYTICS = {
  newAppInstallationUsersClicks: 'Clics',
  installs: 'Installations',
  signups: 'Inscriptions',
  purchases: 'Commandes',
  totalNewsletterSubscribers: 'Adhérents'

};
export const BRANCH_EVENTS = {
  OPEN: 'open',
  REINSTALL: 'reinstall',
  INSTALL: 'installs',
  REGISTRATION: 'signups',
  PURCHASE: 'purchases',
  NEWSLETTER: 'newsLetter',
  CLICK: 'newAppInstallationUsersClicks'
}
export const ANALYTICS_TYPES = {
  HAS_NOT_APPLICATION: 'hasNotApplication',
  ACCEPT_NEWSLETTER: 'acceptNewsLetter',
  HAS_NOT_ACCOUNT: 'hasNotAccount',
  HAS_ACCOUNT: 'hasAccount'
}
export const PUSH_NOTIF_STATUS = {
  pending: { label: 'En cours', color: 'rgb(243 164 6 / 88%)' },
  scheduled: { label: `Programmée`, color: 'rgb(107 142 236 / 82%)' },
  sent: { label: 'Envoyée', color: 'rgb(4 200 40 / 93%)' }
};
export const METHODS = {
  pushNotification: 'push notification'
}
export const PIE = 'pie'
export const FINANCE_COLORS = {
  validateOrder: '#80BA94',
  canceledCmd: '#F0D377',
  missedCmd: '#ff4861',
  positiveRate: '#80BA94',
  negativeRate: '#ff4861',
}
export const DRIVER_STATUS = {
  delivering: 'En livraison',
  available: 'Disponible',
  uninstalled: 'Application désinstallée',
  noNotifications: 'N’a pas accepté les notifications',
  documentsRequired: 'Documents requis',
  unavailable: 'Non disponible'
};
export const CANCELED = 'canceled';
export const RETENTION = 'retention';
export const REACTIVATION_BASKET = 'reactivationBasket';
export const CUSTOMER = 'customer';
export const CANCELLATION_LABELS = {
  shop: 'le restaurant',
  customer: 'le client',
  driver: 'le livreur',
}
export const LEVELS = {
  INFO: 'info',
  ERROR: 'error'
}
export const SEVERITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high'

}
export const helpLink = 'https://share.hsforms.com/2G9bxj9GwQjOzoTxD_x4Vug5lqt9'

export const UNLIMITED_SLOT_LIMIT = 'unlimited'
export const SUPPORT_NUMBER = '+33 1 89 71 52 91'
